import React, { useEffect } from 'react'
import styled from 'styled-components'
import { css } from '@styled-system/css'
import { Swiper, SwiperSlide } from 'swiper/react'

import {
  breakpoints,
  CarouselContainer as unstyledCarouselContainer,
  CarouselNextButton,
  CarouselPrevButton
} from 'ui/acro'
import { useSwiper } from 'hooks'

import { instructors } from '../_media'
import InstructorCard from './InstructorCard'

const CarouselContainer = styled(unstyledCarouselContainer)(
  css({
    '& .swiper-container': {
      'padding-left': ['15px', null, '75px'],
      '@supports (padding: max(1px, 2px))': {
        'padding-left': ['15px', null, 'max(calc((100vw - 1333px)/2), 50px)']
      }
    }
  })
)

const Carousel = () => {
  const { getSwiperProps, goNext, goPrev, isBeginning, isEnd } = useSwiper()

  // This is also used in Redeem/StoryCarousel. We should refactor both out into the useSwiper() hook
  useEffect(() => {
    // We need to dynamically set button positioning because firefox does not support max().
    // We use max() to maintain a dynamic gutter padding on the carousel and position for buttons.
    const isSupported = () => window.CSS.supports('padding', 'max(1px, 2px)')

    const maxWidth = (document.documentElement.clientWidth - 1320) / 2 // total width, minus content width, divided by two gives us the width of a single gutter.

    const initializeButtonPos = () => {
      const prevButton = document.getElementById('carousel-prev-button')
      const nextButton = document.getElementById('carousel-next-button')

      if (prevButton) {
        prevButton.style.right = Math.max(maxWidth + 50, 100) + 'px'
      }

      if (nextButton) {
        nextButton.style.right = Math.max(maxWidth, 50) + 'px'
      }
    }

    // Only adjust button positions manually if max() isn't supported)
    if (!isSupported()) {
      initializeButtonPos()
    }
  }, [])

  return (
    <CarouselContainer mt={['48px', '100px']}>
      <Swiper
        {...getSwiperProps({
          lazy: true,
          slidesPerView: 'auto',
          spaceBetween: 16,
          slidesOffsetAfter: 15,
          watchOverflow: true,
          freeMode: true,
          freeModeSticky: true,
          breakpoints: {
            [breakpoints[1]]: {
              spaceBetween: 40,
              slidesOffsetAfter: 50
            }
          }
        })}
      >
        {instructors &&
          instructors.map((item, index) => (
            <SwiperSlide tag={InstructorCard} {...item} key={index} />
          ))}
      </Swiper>

      <CarouselPrevButton
        handleClick={goPrev}
        disabled={isBeginning}
        display={['none', null, 'inherit']}
        top='-10%'
        id='carousel-prev-button'
        right='max(calc((100vw - 1320px)/2 + 50px), 100px)'
        left={null}
      />
      <CarouselNextButton
        handleClick={goNext}
        disabled={isEnd}
        display={['none', null, 'inherit']}
        top='-10%'
        id='carousel-next-button'
        right='max(calc((100vw - 1320px)/2), 50px)'
      />
    </CarouselContainer>
  )
}

export default Carousel
